import { render, staticRenderFns } from "./ProfileSettingDocuments.vue?vue&type=template&id=10610176&"
import script from "./ProfileSettingDocuments.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports